import { render, staticRenderFns } from "./host-feedback.vue?vue&type=template&id=fabf82d0&scoped=true"
import script from "./host-feedback.vue?vue&type=script&lang=js"
export * from "./host-feedback.vue?vue&type=script&lang=js"
import style0 from "./host-feedback.vue?vue&type=style&index=0&id=fabf82d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabf82d0",
  null
  
)

export default component.exports